export default "__VITE_ASSET__pTRGVR7Q__"